console.log("window.location.hostname:", window.location.hostname);
//console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL); //not used

//export const BASE_URL =  process.env.REACT_APP_API_URL 
//export  const BASE_URL = "http://localhost:4000/api"
export const BASE_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL  

  console.log("BASE_URL being used:", BASE_URL);

class MainApi {

  _getAuthHeaders() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  _checkResponse(res) {
    if (res.ok) {
      return res.json();
    }
  
    return res.json().then((data) => {
      throw new Error(data.error || `Error: ${res.status}`);
    });
  }

  login({ email, password }) {
    return fetch(`${BASE_URL}/users/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body: JSON.stringify({ email, password}),
    }).then(this._checkResponse)
  }
  
  createUser({ data }) {
    return fetch(`${BASE_URL}/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body: JSON.stringify(data),
    }).then(this._checkResponse)
  }

  getUsers(token) {
    return fetch(`${BASE_URL}/users`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
    }).then(this._checkResponse)
  }
  getOneUser(id, token) {
    return fetch(`${BASE_URL}/users/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
    }).then(this._checkResponse);
  }

  updateProfile(id, data){
    const token = localStorage.getItem('token');
    return fetch(`${BASE_URL}/users/${id}/profile`, {
      method: 'PATCH',
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    }).then(this._checkResponse)
  }
  deleteUser(id, token){
    return fetch(`${BASE_URL}/users/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

    checkToken(token) {
    return fetch(`${BASE_URL}/users/me`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(this._checkResponse);
  }


 getMe(tokenOverride) {
  const token = tokenOverride || localStorage.getItem('token');
  return fetch(`${BASE_URL}/users/me`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (res) => {
      const contentType = res.headers.get("content-type");

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Error ${res.status}: ${errorText}`);
      }

      if (!contentType || !contentType.includes("application/json")) {
        const text = await res.text();
        throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
      }

      return res.json();
    })
    .catch((err) => {
      console.error("getMe() failed:", err.message);
      throw err;
    });
}


}

const api = new MainApi({
  baseUrl: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
